import parseYoutubeVideo from './parsers/video';
import { parseVideoItem } from 'api/parsers/video-item';
import { hydratedData } from 'services/hydrated-data';
import { service } from './youtube';

const mapParams = (channel, options) => {
  const { externalId, urlType } = channel;
  return {
    externalId,
    urlType,
    pageToken: options.paging.cursor,
    itemsCount: options.paging.size,
  };
};

const getCategoryIdToTitleMapping = categoryItems =>
  _.reduce(
    categoryItems,
    (categoriesByIds, category) => ({
      [category.id]: category.snippet.title,
    }),
    {},
  );

const addCategory = (categoriesByIds, item) => {
  const categoryId = _.get(item, 'snippet.categoryId');
  const category = categoriesByIds[categoryId];

  if (category) {
    _.set(item, 'snippet.category', category);
  }

  return item;
};

const mapToVodPaginatedResponse = (response, options) => {
  const {
    nextPageToken,
    items,
    videoItems,
    categoryItems,
    channelItems,
  } = response.data;
  const categoriesByIds = getCategoryIdToTitleMapping(categoryItems);
  const channelsData = _.keyBy(channelItems, 'id');
  const addCategoryToVideo = item => addCategory(categoriesByIds, item);

  return {
    status: response.status,
    sort: options.sort,
    paging: {
      ...options.paging,
      cursor: nextPageToken,
    },
    data: _(items)
      .merge(videoItems)
      .map(addCategoryToVideo)
      .map(item => ({
        ...parseYoutubeVideo(item),
        publisher: channelsData[item.snippet.channelId].snippet.title,
      }))
      .value(),
  };
};

const listYoutubeChannelVideosInternal = async (channel, options) => {
  const params = mapParams(channel, options);
  const response =
    hydratedData.getChannelVideosResponse() ||
    (await service.getChannelVideos(params));
  return mapToVodPaginatedResponse(response, options);
};

export const listYoutubeChannelVideos = async (channel, options) => {
  const response = await listYoutubeChannelVideosInternal(channel, options);

  return {
    ...response,
    data: response.data.map(parseVideoItem),
  };
};

export const getYoutubeVideoById = async videoId =>
  service.getVideoById(videoId).then(response => {
    const { items, categoryItems } = response.data;
    const categoriesByIds = getCategoryIdToTitleMapping(categoryItems);
    const item = addCategory(categoriesByIds, items[0]);
    const parsedItem = parseYoutubeVideo(item);

    return {
      ...response,
      data: {
        ...parsedItem,
        id: parsedItem.externalId,
      },
    };
  });
